export default {
  dialogueId: 'Id діалогу',
  readTheDialogueBeforeEvaluation: 'Прочитайте діалог, після чого оцініть його',
  communicationQualitySurveyAnswerRules:
    '1 – зовсім не погоджуєтесь, 12 – цілковито погоджуєтесь',
  survey: 'Опитування'
};
